<template>
  <a-modal
    :title="title"
    width="40%"
    :visible="visible"
    :confirm-loading="confirmLoading"
    :maskClosable="false"
    :keyboard="false"
    @cancel="handleCancel"
    @ok="submit"
    ok-text="保存"
    cancel-text="取消"
    :destroyOnClose="true"
  >
    <div>
      <a-form-model
        ref="ruleForm"
        :model="form"
        :rules="rules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item label="名称" prop="brandName">
          <a-input v-model="form.brandName" />
        </a-form-model-item>
        <a-form-model-item label="年度" >
          <a-date-picker
            placeholder="请选择年份"
            v-model="form.acquireYear"
            :open="yearShowOne"
            :locale="locale"
            :format="'YYYY'"
            mode="year"
            @openChange="openChangeOne"
            @panelChange="panelChangeOne"
            @change="handleClearAcquireYear"
          />
        </a-form-model-item>
        <a-form-model-item label="级别" prop="levelType">
          <div class="flex">
            <a-select v-model="form.levelType">
              <a-select-option :value="item.text" v-for="item in jblist" :key="item.text">{{
                item.title
              }}</a-select-option>
             <!-- <a-select-option value="其他" >{{
                item.title
              }}</a-select-option> -->
            </a-select>
            <template v-if="form.levelType == '其他'">
              <a-input v-model="form.otherLevelType" class="ipt-other" />
            </template>
          </div>
        </a-form-model-item>
      </a-form-model>
    </div>
  </a-modal>
</template>
    
  <script>
import { getAction, postAction, putAction } from "@/api/index";
import zh_CN from "ant-design-vue/lib/locale-provider/zh_CN";
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";
import moment from "moment";
import "moment/locale/zh-cn";
import BaseEditor from "@/components/common/BaseEditor.vue";
moment.locale("zh-cn");
export default {
  data() {
    return {
      visible: false,
      confirmLoading: false,
      labelCol: { span: 4 },
      wrapperCol: { span: 16 },
      other: "",
      form: {
        applyId: "",
        title: "",
        acquireYear: "",
        achievementType: "",
        amount: "",
        levelType: "",
        content: "",
        courseType: "",
        otherLevelType: "",
        otherType:'',
        brandName:'',
      },
      rules: {
        brandName: [
          {
            required: true,
            message: "请输入名称",
            trigger: "blur",
          },
        ],
        acquireYear:[
          {
            required: true,
            message: "请选择年度",
            validator: (rule, value, callback) => {
                if (this.form.acquireYear!='') {
                  callback(); // 验证通过
                } else {
                  callback(new Error('请选择年度'));
                }
              },
            trigger: "change",
          },
        ],
         levelType: [
          {
            required: true,
            message: "请选择级别",
            trigger: "change",
          },
        ],
      },
      yearShowOne: false,
      zh_CN,
      locale,
      applyType: 1,
      // 添加还是编辑
      type: "",
      // 弹框标题
      title: "",
      xwlist: [],
      jblist: [],
      kclist: [],
      ishow: false,
      ifirst: true,
    };
  },
  components: { BaseEditor },
  mounted() {
  },
  methods: {
    openChangeOne(status) {
      if (status) {
        this.yearShowOne = true;
      }
    },
    handleClearAcquireYear(val) {
      this.form.acquireYear = ""; // 或者适当的空值，根据你的业务需求
      this.$forceUpdate();
    },
    panelChangeOne(value) {
      const year = moment(value).format('YYYY');
      this.form.acquireYear =year+"";
      this.yearShowOne = false;
      this.$refs.ruleForm.clearValidate("acquireYear");
    },
    init(type, record) {
      this.type = type;
      this.visible = true;
        this.getcgjb();
      if (type == "add") {
        this.form = {};
        // this.form.applyId = record.id;
        this.title = "新增培育品牌";
        this.form.acquireYear=new Date().getFullYear()+"";
      } else {
        this.title = "编辑培育品牌";
        this.form = {
          acquireYear: record.acquireYear?record.acquireYear:'',
          id: record.id,
          levelType: record.levelType,
          otherLevelType: record.otherLevelType,
          // otherType: record.otherType,
          brandName:record.brandName
        };
      }
    },
     getcgjb() {
      // this.jblist = [
      //   {
      //     value: "国家级",
      //     title: "国家级",
      //   },
      //   {
      //     value: "省级",
      //     title: "省级",
      //   },
      //   {
      //     value: "市级",
      //     title: "市级",
      //   },
      //   {
      //     value: "县级",
      //     title: "县级",
      //   },
      //   {
      //     value: "校级",
      //     title: "校级",
      //   },
      //   {
      //     value: "其他",
      //     title: "其他",
      //   },
      // ];
      getAction("/baseCommon/getDictItemsByCode?code=achievement_level",).then((res) => {
      	if (res.code == 200) {
      		this.jblist=res.result;
      	}
      });
    },
    handleCancel() {
      this.visible = false;
    },
    submit() {
      if (
        typeof this.form.acquireYear == "object" &&
        this.form.acquireYear != "" 
      ) {
        this.form.acquireYear =
          new Date(this.form.acquireYear).getFullYear()+"";
      }
      this.$refs.ruleForm.validate((valid) => {
       
        if (valid) {
         
          if (this.type == "add") {
             let params = this.form;
              this.visible = false;
              this.$message.success("添加成功");
              this.$emit("addGain",{record:params,type:'add'});
            // params.applyType = this.applyType;
            //   postAction("/lx/lxCultivateBrand/add", params).then((res) => {
            //     if (res.code == 200) {
            //       this.visible = false;
            //       this.$message.success("添加成功");
            //       this.$emit("addGain");
            //     } else {
            //       this.$message.error(res.message);
            //     }
            //   });
           
            
          } else {
            let params = this.form;
            if (typeof this.form.acquireYear == "object") {
              params.acquireYear =
                new Date(this.form.acquireYear).getFullYear() + "";
            }
            this.visible = false;
            this.$message.success("编辑成功");
            this.$emit("addGain",{record:params,type:'edit'});
            // params.applyType = this.applyType;
            // putAction("/lx/lxCultivateBrand/edit", params).then((res) => {
            //   if (res.code == 200) {
            //     this.visible = false;
            //     this.$message.success("编辑成功");
            //     this.$emit("addGain");
            //   } else {
            //     this.$message.error(res.message);
            //   }
            // });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>
  
  <style lang="scss" scoped>
/deep/ .ant-modal-title {
  text-align: center;
}
/deep/ .ant-input-number-handler-wrap {
  display: none;
}
</style>
  